import { coreI18n } from '@/lang/core';
import { createI18n } from '@/platform/i18n/createI18n';
import { createAppRouter } from '@/platform/router/createAppRouter';
import { createAppStore } from '@/platform/store/createAppStore';

import type { AppDefinition } from './contracts';

/**
 * Turns a definition into runtime pieces: the store with every module slice
 * injected, i18next with exactly the shipped namespaces, and the router.
 */
export function createApp(app: AppDefinition) {
  const { store, persistor, resetState } = createAppStore({
    appId: app.id,
    slices: app.modules.flatMap((m) => m.slices ?? []),
    persistedSlices: app.modules.flatMap((m) => m.persist ?? []),
    persist: app.persist,
    extra: { auth: app.auth, onAuthenticated: app.onAuthenticated },
  });

  const i18n = createI18n({
    brandName: app.brand.name,
    bundles: [
      coreI18n,
      ...app.modules.flatMap((m) => (m.i18n ? [m.i18n] : [])),
      ...(app.i18n ? [app.i18n] : []),
    ],
  });

  const router = createAppRouter(app);

  return { store, persistor, resetState, i18n, router };
}

export type AppRuntime = ReturnType<typeof createApp>;
